import { REQUEST_TYPES } from "utils/appConstant";
import { apiInstance2 } from "utils/apiInstance";

const { POST } = REQUEST_TYPES;

const apis = {
  searchWidgetAnalytics: ({ data, page }) =>
    apiInstance2(`/trapmen/widget_log_check/?page=${page}`, {
      method: POST,
      data,
    }),

  getWidgetAnalyticsDetails: ({ tribe_account_id }) =>
    apiInstance2(`/trapmen/fetch_tribe_details/${tribe_account_id}/`, {
      method: "GET",
    }),

  getWidgetAnalytics: ({ payload, page }) =>
    apiInstance2(`/trapmen/widget_log_check/?page=${page}`, {
      method: "POST",
      body: payload,
    }),

  searchWidgetAnalyticsTransactions: ({ payload }) =>
    apiInstance2(`/trapmen/direct_general_tx_search/`, {
      method: "POST",
      body: payload,
    }),

  getWidgetAnalyticsGraphData: (payload) =>
    apiInstance2(`/trapmen/month_on_month_dc_report/`, {
      method: "POST",
      body: payload,
    }),
  getTransactionDetails: ({ transaction_id, tribeRef }) =>
    apiInstance2(`/trapmen/single_general_transaction/${transaction_id}/`, {
      headers: {
        "MERCHANT-TRIBE-REF": tribeRef,
      },
    }),
};

export default apis;
